export const getEnvVariables = () => ({
  ...process.env,
  elevenlabsApiKey: process.env.REACT_APP_ELEVENLABS_API_KEY,
  nodeEnv: process.env.REACT_APP_NODE_ENV,
});
